<template>
  <div class="task_list">
    <div class="task_list_top">
      <div class="right">
        <el-input
            style="width: 200px;"
            placeholder="请输入要搜索的名称"
            @keyup.enter.native="search"
            v-model="name">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button class="create" @click="toCreate">创建规则</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
          class="customer_list_table"
          :data="data.list"
          :header-cell-style="{background:'rgb(249,249,249)'}"
          ref="multipleTable"
          :row-style="{height: '60px'}">
        <el-table-column
            prop="name"
            align="left"
            label="名称">
			<template v-slot="scope">
				<span v-if="curfield_power.name != 3">
					{{scope.row.name}}
				</span>
			</template>
        </el-table-column>
        <el-table-column
            prop="member_name"
            align="center"
            label="创建人">
          <template v-slot="scope">
               <span style="border: 1px solid;padding: 5px 10px;border-radius: 2px" v-if="curfield_power.member_id != 3">
                <span>
                  <i>
                  <svg t="1620206845175" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2069" width="16" height="16"><path d="M623.1 604.2c-4.7 0-37.3-18.2-18.6-77.4 51.2-54.6 93.1-141.1 93.1-223 0-132-88.5-200.2-186.3-200.2-102.4 0-186.3 68.3-186.3 200.2 0 86.5 41.9 172.9 93.1 227.5 18.6 50.1-18.6 72.8-27.9 72.8C287.8 645.1 162 713.3 162 781.6V809c0 91 181.6 113.8 349.2 113.8S860.6 900 860.6 809v-27.3c0-72.8-125.7-141.1-237.5-177.5z m0 0" fill="#1296db" p-id="2070"></path></svg>
                </i>
                </span>
                {{scope.row.member_name}}
              </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="create_time"
            align="center"
            label="创建时间">
			<template v-slot="scope">
				<span v-if="curfield_power.create_time != 3">
					{{scope.row.create_time}}
				</span>
			</template>
        </el-table-column>
        <el-table-column
            prop="is_lock"
            align="center"
            label="开关">
          <template v-slot="scope">
			  <span  v-if="curfield_power.is_lock != 3">
				  <el-switch
				      v-model="scope.row.is_lock"
				      :active-value="1"
				      :inactive-value="0"
				      @change="changeSwitch(scope.row.id, scope.row.is_lock)"
				      active-color="var(--themeColors)"
				      inactive-color="rgb(220,223,230)">
				  </el-switch>
				  <span v-if="scope.row.is_lock === 1" style="margin-left: 5px;">已开启</span>
				  <span v-if="scope.row.is_lock === 0" style="margin-left: 5px;">已关闭</span>
			  </span>
           
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200">
          <template v-slot="scope">
            <span class="tab_btn" @click="open_select_group(scope.row)">添加群聊</span>
            <span class="tab_btn" @click="editRule(scope.row.id)">修改</span>
            <span class="tab_btn" @click="toDetails(scope.row.id)">详情</span>
            <span class="tab_btn" @click="" style="color: rgb(249, 104, 104);">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="btn_right">
        <div style="float: right">
          <el-pagination
              background
              layout="total,sizes, prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :page-sizes="[20, 50, 100, 200, 500]"
              :page-size="data.pagesize"
              :pager-count='5'
              @size-change="type_modify_page"
              @current-change="type_switch_page"
              :total="data.total">
          </el-pagination>
        </div>
      </div>
    </div>


    <Dialog :show.sync="select_group_show" :name_width="select_group_dialog" class="select_group_dialog">
      <span slot="body">
        <div class="group_box">
          <div class="group_list">
            <div style="padding-right: 20px; padding-bottom: 20px">
              <el-input
                  placeholder="请输入内容"
                  v-model="group.group_name">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="title">可用群聊：（{{group.total}}）</div>
            <div class="list">
              <div class="list_item" @click="clickItem(value, index)" v-for="(value, index) in group.list">
                <div class="item_content">
                  <div style="display: flex">
                    <img class="avatar" src="https://assets.weibanzhushou.com/web/we-work-webapp/avatar-room-default.67bead38e751.svg" alt="">
                    <div class="group_info">
                      <span class="name">{{value.chat_name}}</span>
<!--                      <span class="group_total">群主：{{value.group_leader}}</span>-->
                    </div>
                  </div>

                  <div class="action">
                    <i v-show="!value.choice">
                      <svg v-show="value.checked === true" t="1620627286226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8363" width="20" height="20"><path d="M527.519973 877.43083c-51.583842 0-101.629655-10.105149-148.749836-30.036084-45.50745-19.24839-86.37216-46.798862-121.464399-81.891102s-62.644759-75.958996-81.892125-121.465422c-19.930935-47.120181-30.036084-97.167017-30.036084-148.750859 0-51.584865 10.105149-101.630678 30.036084-148.750859 19.249413-45.506427 46.799886-86.373183 81.892125-121.465422 35.092239-35.092239 75.958996-62.644759 121.464399-81.892125 47.120181-19.929912 97.165993-30.03506 148.749836-30.03506 51.584865 0 101.631702 10.105149 148.750859 30.03506 45.50745 19.24839 86.373183 46.799886 121.465422 81.892125 35.092239 35.092239 62.644759 75.958996 81.891102 121.466446 19.930935 47.119157 30.036084 97.16497 30.036084 148.749836 0 51.583842-10.105149 101.630678-30.036084 148.750859-19.24839 45.506427-46.798862 86.373183-81.891102 121.465422s-75.958996 62.644759-121.465422 81.891102C629.151675 867.325681 579.104839 877.43083 527.519973 877.43083zM889.197316 495.28634M165.842631 495.28634M485.271754 643.157155 711.679273 394.624732c3.805676-4.178159 3.504824-10.650571-0.673335-14.456247s-10.650571-3.5038-14.456247 0.673335l-219.675188 241.142106L326.597895 491.37117c-4.266164-3.708462-10.730389-3.255137-14.435781 1.010003-3.707438 4.26514-3.255137 10.729365 1.010003 14.436804l157.822468 137.171126c1.936095 1.682315 4.326539 2.509147 6.709819 2.509147C480.485751 646.49825 483.255841 645.370567 485.271754 643.157155z" p-id="8364" fill="#27A538"></path></svg>
                      <svg v-show="value.checked === false" t="1620627324743" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9328" width="18" height="18"><path d="M812.698413 212.746384c79.825044 79.825044 121.362963 180.238448 124.613757 300.517813-3.250794 119.918166-44.788713 219.97037-124.613757 300.156614-79.825044 80.186243-179.877249 121.724162-299.795414 124.252557-120.640564-2.528395-220.692769-44.066314-300.517813-124.252557-79.825044-80.186243-121.362963-180.238448-124.613757-300.156614 3.250794-120.640564 44.788713-220.692769 124.613757-300.517813 79.825044-79.825044 179.877249-121.362963 300.517813-124.613757C633.182363 91.383422 732.873369 132.92134 812.698413 212.746384zM786.692063 791.387654c72.962257-72.962257 110.888183-164.345679 114.138977-274.150265-3.250794-109.804586-41.17672-201.188007-114.138977-274.150265-72.601058-72.962257-163.98448-110.888183-273.789065-113.416578C402.737213 131.837743 311.353792 169.763668 238.391534 243.087125c-72.962257 72.962257-110.888183 164.345679-114.138977 274.150265 3.250794 109.804586 41.17672 201.188007 114.138977 274.150265 72.601058 72.962257 164.345679 110.888183 274.872663 113.416578C622.707584 902.275838 714.091005 864.349912 786.692063 791.387654z" p-id="9329" fill="#515151"></path></svg>
                    </i>
                    <span v-show="value.choice">该群聊已设置规则</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
      <div slot="footer">
        <el-button type="primary" @click="save_select_group">保 存</el-button>
        <el-button @click="close_select_group">取 消</el-button>
      </div>
    </Dialog>

    <!--    删除弹窗-->
    <Dialog :show.sync="del_show" :name_width="del_dialog" class="dialog">
      <span slot="body">
        <p>确定删除这个字段吗？</p>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="save_del_dialog">确 定</el-button>
        <el-button @click="close_del_dialog">取 消</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "components/content/dialog/Dialog";

import {getCustomerBaseTaskList, delCustomerBaseTask, setCustomerBaseTaskLock, setCustomerBaseTaskBase} from 'network/hk_qiwei'
import {getCustomerBaseList} from 'network/hk_operate'
import {
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled ,
	} from '@src/network/kh_public'
export default {
  name: "TaskList",
  components: {
    Dialog
  },
  data() {
    return {
		curfield_power: '',
		curkey: 'customer_base_task',
		
		
		is_powerAdd: false,
		is_powerEdit: false,
		is_powerDel: false,
		is_powerImp: false,
		is_powerExp: false,
		is_powerRec: false,
		
      select_group_show: false,
      select_group_dialog: {
        name: '选择群聊',
        width: '500px'
      },
      // 删除弹窗
      del_show: false,
      del_dialog: {
        name: '删除字段',
        width: '300px'
      },
      del_id: null,

      data: {
        pagesize: 20,
        page: 1,
        total: 0,
        list: []
      },

      // 客户群列表
      group: {
        group_name: '',
        pagesize: 20,
        page: 1,
        total: 0,
        list: []
      },

      name: '',

      // 添加群聊 ->
      // 当前选择的群聊
      thisGroup: [],
      // 当前选择的任务
      thisTaskId: null,
      taskInfo: {}
    }
  },
  created() {
    this.getCustomerBaseTaskList(this.data.pagesize, this.data.page)
	this.judgePower()
	 this.curfield_power = retfieldPower(this.curkey)
  },
  methods: {
	  judgePower() {
	  	this.is_powerAdd = retupower('184')
	  	this.is_powerEdit = retupower('185')
	  	this.is_powerDel = retupower('186')
	  	this.is_powerImp = retupower('187')
	  	this.is_powerExp = retupower('188')
	  	this.is_powerRec = retupower('189')
	  },
    toCreate() {
		if(retujudpower(this.is_powerAdd)) {
			this.$router.push({path: '/qiwei/group_task/create'})
			
		}
    },
    toDetails(id) {
      this.$router.push({path: '/qiwei/group_task/task_details', query:{id: id}})
    },

    editRule(id) {
		if(retujudpower(this.is_powerEdit)) {
			this.$router.push({path: '/qiwei/group_task/create', query: {id: id}})
			
		}
    },

    // 选择群聊弹窗
    open_select_group(row) {
		if(retujudpower(this.is_powerEdit)) {
			this.thisTaskId = row.id
			this.taskInfo = row
			this.getCustomerBaseList(this.group.pagesize, this.group.page)
			this.select_group_show = true
		}
    
    },
    save_select_group() {
      this.setCustomerBaseTaskBase(this.thisTaskId, this.thisGroup.join())
    },
    close_select_group() {
      this.select_group_show = false
    },

    // 添加群聊弹窗
    clickItem(value, index) {
      if (value.choice) {

      } else {
        this.group.list[index].checked = !this.group.list[index].checked
        if (this.group.list[index].checked) {
          this.thisGroup.push(value.id)
        } else {
          let index1 = this.thisGroup.indexOf(value.id)
          this.thisGroup.splice(index1, 1,)
        }
      }
    },

    type_modify_page(val) {
      this.data.pagesize = val
      this.getCustomerBaseTaskList(this.data.pagesize, this.data.page, this.name)
    },
    type_switch_page(val) {
      this.data.page = val
      this.getCustomerBaseTaskList(this.data.pagesize, this.data.page, this.name)
    },

    delTask(id) {
      this.delCustomerBaseTask(id)
    },
    search() {
      this.getCustomerBaseTaskList(this.data.pagesize, this.data.page, this.name)
    },
    // 任务开关
    changeSwitch(id, is_lock) {
      this.setCustomerBaseTaskLock(id, is_lock)
    },

    // 删除弹窗
    open_del_dialog(id) {
      this.del_id = id
      this.del_show = true
    },
    save_del_dialog() {
		if(retujudpower(this.is_powerDel)) {
			this.delCustomerInfoConfig(this.del_id)
			
		}
    },
    close_del_dialog() {
      this.del_show = false
    },


    // 任务列表
    getCustomerBaseTaskList(pagesize, page, name) {
      getCustomerBaseTaskList(pagesize, page, name).then(res => {
        if (res.code === 10000) {
          this.data.list = res.result.data
          this.data.total = res.result.total
        }
      })
    },
    // 删除任务
    delCustomerBaseTask(id) {
      delCustomerBaseTask(id).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '删除成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerBaseTaskList(this.data.pagesize, this.data.page, this.name)
        }
      })
    },
    // 任务开关
    setCustomerBaseTaskLock(id, is_lock) {
      setCustomerBaseTaskLock(id, is_lock).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '切换成功',
            type: 'success',
            offset: 100
          });
        }
      })
    },
    // 客户群列表
    getCustomerBaseList(pagesize, page) {
      getCustomerBaseList(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.group.list = res.result.data
          let group_id_list =  this.taskInfo.customer_base_id.split(",").map(Number);
          this.thisGroup =  JSON.parse(JSON.stringify(this.taskInfo.customer_base_id.split(",").map(Number)));
          for (let index in this.group.list) {
            if (group_id_list.indexOf(this.group.list[index].id) !== -1) {
              this.$set(this.group.list[index],'checked',true);
              this.$set(this.group.list[index],'choice',true);
            } else {
              this.$set(this.group.list[index],'checked',false);
              this.$set(this.group.list[index],'choice',false);
            }

          }
          this.group.total = res.result.total
        }
      })
    },
    // 添加群聊
    setCustomerBaseTaskBase(id, customer_base_id) {
      setCustomerBaseTaskBase(id, customer_base_id).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '添加成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerBaseTaskList(this.data.pagesize, this.data.page, this.name)
          this.select_group_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },

  }
}
</script>

<style scoped>
.task_list .task_list_top {
  width: 100%;
  height: 55px;
  background: #fff;
}
.task_list .task_list_top .create {
  margin-left: 5px;
  padding: 0 15px;
  border: none;
  background: var(--themeColors);
  color: #fff;
  height: 32px;
}
.task_list .task_list_top .create:hover {
  background: var(--themeColorsHover);
}

.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.select_group_dialog .group_box {
  height: 366px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.select_group_dialog .group_box .group_list {
  position: relative;
  -webkit-box-flex: 1;
  flex: 1;
  height: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 50%;
}
.group_box .group_list .title {
  color: #666;
  font-size: 13px;
}
.group_box .group_list .list, .group_box .selected_list .list {
  margin-top: 8px;
  overflow: auto;
  -webkit-box-flex: 1;
  flex: 1;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item, .group_box .selected_list .list .list_item{
  width: 100%;
  margin-bottom: 10px;
  height: 50px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 20px 10px 0;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item:hover {
  background: rgb(234,247,238);
}
.group_box .group_list .list .list_item .item_content {
  -webkit-box-flex: 1;
  flex: 1;
  overflow: hidden;
  margin-right: 10px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  justify-content: space-between;
}
.group_box .group_list .list .list_item .item_content .avatar {
  height: 40px;
  margin-right: 10px;
}
.group_box .group_list .list .list_item .item_content .group_info {
  width: 197px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item .item_content .group_info .name {
  color: rgba(0,0,0,.65);
  font-size: 14px;
  -webkit-box-flex: 1;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.group_box .group_list .list .list_item .item_content .group_info .group_total {
  font-size: 12px;
  color: rgba(0,0,0,.45);
}

.btn_right {
  height: 50px;
  margin-top: 15px;
  margin-right: 10px;
}
.table {
  background: #fff;
}
</style>